import {h, Component} from 'preact';
import cx from 'classnames';
import {$CONTENT_WINDOW} from '@config/selectors';
import {jquerySmartResize, Waypoints} from '@modules/lazy-imports';
import Icon from '@components/common/Icon';
import $ from '@modules/jquery-import';

class PageNavigation extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            nodeList: props.nodeList,
            navList: [],
            activeId: null,
            indicator: {
                position: 0,
                width: 0
            }
        };
    }

    async componentDidMount() {
        this.setState( {
            navList: Array.from( this.nav.querySelectorAll( 'a' ) )
        } );

        await Waypoints();

        this.state.nodeList.forEach( node => {
            const context = document.querySelector( $CONTENT_WINDOW );
            new Waypoint( {
                context,
                element: node.el,
                handler: this.handleWaypoint( 'down' ),
                offset: 120
            } );
            new Waypoint( {
                context,
                element: node.el,
                handler: this.handleWaypoint( 'up' ),
                offset: -96
            } );
        } );

        await jquerySmartResize();
        // update indicator position on window resize
        $( window ).smartresize( e => {
            this.setIndicatorPosition( this.state.activeId )
        } );
    }

    handleWaypoint( handleDir ) {
        const self = this;
        return function ( currentDir ) {
            if ( currentDir !== handleDir || $( upi.conf.SCROLL_CONTEXT ).data( 'is-scroll-animating' ) ) {
                // only set active if page scroll is not hijacked
                return;
            }
            const id = this.element.getAttribute( 'id' );
            self.setActiveNavItem( id );
        };
    }

    setActiveNavItem( id ) {
        this.setState( {activeId: id} );
        this.setIndicatorPosition( id );
    }

    setIndicatorPosition( id ) {
        const node = this.state.navList.find( node => node.id === id );

        // reset to "0" if node not set
        const {width, x} = Boolean( node )
            ? node.getBoundingClientRect()
            : {x: 0, width: 0};

        this.setState( {
            indicator: {
                position: x,
                width: width
            }
        } );

    }

    getIndicatorStyle() {
        const {indicator} = this.state;
        return {
            transform: `translate3d(${indicator.position}px,0,0)`,
            opacity: 1.0,
            width: indicator.width
        };
    }

    render( {nodeList}, context ) {
        if ( !nodeList.length ) {
            return null;
        }

        const navItemClass = ( isActive ) => cx( 'py-4 px-2', {
            'nav-item--active': isActive
        } );

        return (
            <div id="page-secondary-nav" className="page-secondary-nav">
                <nav ref={ref => this.nav = ref} className="contain-content relative flex justify-between pr-12">

                    {nodeList.map( node =>
                        <a data-auto-scroll
                           id={node.id}
                           onClick={( e ) => this.setActiveNavItem( node.id )}
                           className={navItemClass( this.state.activeId === node.id )}
                           href={`#${node.id}`}>{node.label}</a> )
                    }

                    <a data-auto-scroll href="#top"
                       onClick={( e ) => this.setActiveNavItem( null )}
                       className="page-secondary-nav--top px-4 py-3 mr-2 bg-brand text-white hover:text-white rounded-b shadow-1">
                        <Icon.ui name="arrow-up" className="icon text-xl block"/>
                        Top
                    </a>

                </nav>
                <span className="nav-selection-indicator" style={this.getIndicatorStyle()}></span>
            </div>
        );
    }
}

export default PageNavigation;